import { React } from "react";
import { ModalPopup, MultiStageModalPopup } from "./modal";
import Iconmoon from "../IconsFiles/icon";
import warning from "../../Assets/Icons/warning.png";
import { Button } from "antd";
const MultiStageConfirmationModal = ({
    visible,
    icon,
    param,
    cancelAction,
    markAsRejected,
    markAsProduced,
    children,
  }) => {
    return (
        <MultiStageModalPopup visible={visible}>
            <div className="Popup-img">
                <img src={icon} alt="Warning" />
            </div>
            <div className="Popup-content">{children}</div>
            <div className="ant-modal-footer-section">
                <div style={{marginLeft:"-2px"}}>
                    <Button
                    key="back"
                    style={{minWidth:"80px"}}
                    className="themeBtn-plane"
                    onClick={() => cancelAction(param)}
                    >
                    <div className="plusPopUpBorder">
                        <Iconmoon
                        icon="plus-sign"
                        size={9}
                        color="#EA655B"
                        className="ant-ico-sec"
                        />
                    </div>
                        Cancel
                    </Button>
                </div>
                <div style={{marginLeft:"-10px", marginRight:"11px"}}>
                    <Button
                    key="back"
                    className="themeBtn-plane"
                    
                    onClick={() => markAsRejected(param)}
                    >
                    <div className="plusPopUpBorder">
                        <Iconmoon
                        icon="plus-sign"
                        size={9}
                        color="#EA655B"
                        className="ant-ico-sec"
                        />
                    </div>
                        Mark as Rejected
                    </Button>
                </div>
                <div style={{marginLeft:"-21px"}}>
                    <Button
                        key="submit"
                        className="themeBtn"
                        style={{padding:"4px 7px"}}
                        onClick={() => markAsProduced(param)}
                        >
                        <Iconmoon icon="tick-mark" size={14} color="#ffff" />
                        Mark as Produced
                    </Button>
                </div>
            </div>
        </MultiStageModalPopup>
    )   
};
export default MultiStageConfirmationModal;
